import { RdsBaseParameters, serializeBaseUrlParam } from './parameters.model';
import { serializeArrayToUrlParams } from './serialization-functions.model';

/**
 * Various parameters for Select REST calls
 */
export interface SelectParameters extends RdsBaseParameters {
  /** Number of columns to query */
  collimit?: number;
  /** Column number to start at */
  coloffset?: number;
  /** Regular expression to search columns */
  cols?: Array<string>;
  /** Whether to return a count of all the records in the database that match the query */
  count?: boolean;
  /**  Filter for the query */
  where?: string;
}

/**
 * Given SelectParameters, serialize them to be used as
 * URL parameters
 *
 * @param  options options to serialize
 * @returns serialized string as a urlParameter
 */
export function serializeSelectOptionsUrlParams(options: SelectParameters): string {
  if (!options) {
    return '';
  }
  let path = '';
  for (const prop in options) {
    if (options.hasOwnProperty(prop)) {
      const value = options[prop];
      switch (prop) {
        case 'cols':
          path += serializeArrayToUrlParams(prop, value);
          break;
        default:
          path += serializeBaseUrlParam(prop, value);
      }
    }
  }

  // Remove trailing ampersand
  if (path[path.length - 1] === '&') {
    path = path.substr(0, path.length - 1);
  }

  return path;
}
